import React from 'react';
// @ts-ignore
import Fade from '@stahl.luke/react-reveal/Fade';
import FaqEntry from './FaqEntry';

export default function FaqPageSection() {
  return (
    <section id="faq" className="bg-white main-screen-container overflow-hidden md:overflow-visible relative flex justify-center pb-12 md:pb-0 mt-8 px-4 md:px-6">
      <div className="max-w-6xl w-full px-4 md:px-6 my-12 md:my-20">
        <Fade top>
          <h2 className="text-main-900 text-5xl font-extrabold">Frequently Asked Questions</h2>
        </Fade>

        <Fade top>
          <h3 className="mt-12 text-3xl text-main-900 font-extrabold mb-4">General questions</h3>
        </Fade>

        <Fade top>
          <FaqEntry
            title="What areas of Life Sciences does Nucleo serve?"
            content={(
              <>
                <p className="text-base text-neutral-800 pb-2">
                  On Products, Nucleo provides a wide encompassing platform to give exposure to any
                  professional or company, of any size. Nucleo supports suppliers and users for the following
                  type of products:
                </p>
                <ul className="list-disc pl-6 text-base text-neutral-800 pb-2">
                  <li>Generics</li>
                  <li>Innovative Brands</li>
                  <li>Over-the-Counter (OTC)</li>
                  <li>Specialty Pharma</li>
                  <li>Rare Disease medicines</li>
                  <li>Biopharmaceuticals</li>
                  <li>Academic Medicine</li>
                  <li>Medical Devices</li>
                </ul>
                <p className="text-base text-neutral-800 pb-2">
                  On the Services&apos; side, Nucleo provides a strong networking and social interaction platform
                  for all providers to offer their services within the Life Sciences industry, including the
                  following categories:
                </p>
                <ul className="list-disc pl-6 text-base text-neutral-800 pb-2">
                  <li>Regulatory</li>
                  <li>Pharmacovigilance & MAH</li>
                  <li>Quality</li>
                  <li>CMDO</li>
                  <li>Logistics & 3/4PL providers</li>
                  <li>Distribution & Representation</li>
                  <li>Legal</li>
                  <li>Brokerage & Advisory</li>
                  <li>Commercial</li>
                  <li>Sales, Marketing & Promotional</li>
                </ul>
              </>
            )}
          />
        </Fade>

        <Fade top>
          <FaqEntry
            title="Is Nucleo live?"
            content={`
            Yes, Nucleo is live, with a fully functioning environment.
            `}
          />
        </Fade>

        <Fade top>
          <FaqEntry
            title="How do I know if my industry area is being served?"
            content={`
            Nucleo aims to serve all industry areas within Life Sciences. If you feel your industry area is
            under represented, please contact us: contact@go-nucleo.com.
            `}
          />
        </Fade>

        <Fade top>
          <FaqEntry
            title="How many users are currently using our technology?"
            content={`
            Currently our Technology serves more than 1,000 Life Sciences accounts.
            `}
          />
        </Fade>

        <Fade top>
          <FaqEntry
            title="Is Nucleo available in my country or region?"
            content={`
            Nucleo is planning on availability in all global regions, although please note that it may take
            some time for a comprehensive offering in all countries and regions as the platform is being
            evolved.
            `}
          />
        </Fade>

        <Fade top>
          <FaqEntry
            title="Is Nucleo available in my language?"
            content={`
            Nucleo is planning on availability in all global languages. If you experience any difficulty
            accessing information in your language please send your questions direct, in your local
            language to contact@go-nucleo.com. One of our representatives will be in touch.
            `}
          />
        </Fade>

        <Fade top>
          <FaqEntry
            title="What if I have question not covered by this FAQ?"
            content={`
            If you have any questions not covered by this FAQ please send your question direct
            to contact@go-nucleo.com. One of our representatives will be in touch.
            `}
            showBorder={false}
          />
        </Fade>

        <Fade top>
          <h3 className="mt-6 text-3xl text-main-900 font-extrabold mb-4">
            Medicinal products and product availability
          </h3>
        </Fade>

        <Fade top>
          <FaqEntry
            title="Should I search Products by brand tradename or by generic name?"
            content={`
            It is recommended to search the Nucleo database by I.N.N. as this will ensure the most
            comprehensive search. However, branded or tradenames may also be inputted by a client
            and can show up in your search results.
            `}
          />
        </Fade>

        <Fade top>
          <FaqEntry
            title="How do I know if a listed product is currently marketed or available for licensing in a country or region?"
            content={`
            A product is uploaded and completed by the offering company and information are displayed
            in the parameters of "Commercialized" - you see the list of the countries where the product
            is licensed or commercialized. It's up to the offering company to be as detailed as possible
            to allow the full search functionality.
            `}
          />
        </Fade>

        <Fade top>
          <FaqEntry
            title="Does Nucleo provide information on safety, efficacy and side effects?"
            content={`
            Nucleo does not hold any formal authorisations to engage in direct procurement or supply of
            medicinal products. We are simply a connecting platform. Users should contact each company
            directly for any queries related to the supply, usage and safety of their products.
            `}
          />
        </Fade>

        <Fade top>
          <FaqEntry
            title="Can I find availability of products for rare diseases?"
            content={`
            Nucleo's database of users will contain manufacturers and suppliers of specialty products,
            including products used in the underserved and rare disease space. We encourage users to
            either contact these companies direct via the platform or to post their query in one of our
            Groups to alert suppliers to such demand.
            `}
          />
        </Fade>

        <Fade top>
          <FaqEntry
            title="Can Nucleo help me with sourcing of unlicensed products, named-patient or compassionate use programs?"
            content={`
            Nucleo is not involved in with unlicensed product, patient name basis or compassionate
            forms of supply. However, given the extensive network, you may be able to connect with
            another user who can directly assist you with your query. Our Groups function can also
            be used to post such queries.
            `}
            showBorder={false}
          />
        </Fade>

        <Fade top>
          <h3 className="mt-6 text-3xl text-main-900 font-extrabold mb-4">
            Services
          </h3>
        </Fade>

        <Fade top>
          <FaqEntry
            title="How to list the Services my company or myself provide?"
            content={`
            Choose multiple selection of the drop down menu, or start type and pick one.
            `}
          />
        </Fade>

        <Fade top>
          <FaqEntry
            title="My company or myself provides multiple Services offerings, should I list them all?"
            content={`
            There is provision via the 'Add Service' tab to input multiple services.
            `}
          />
        </Fade>

        <Fade top>
          <FaqEntry
            title="My Services are not listed in the drop down menu, how do I describe them?"
            content={`
            Select the most appropriate general category from those listed, and then to elaborate on
            a brief description of the service offering in the free text box under the Services header.
            `}
          />
        </Fade>

        <Fade top>
          <FaqEntry
            title="The Services provided by my company or by myself are available in a brochure, how should I proceed?"
            content={`
            We recommend to attach these in pdf format at the link provided below the Services listings.
            `}
          />
        </Fade>

        <Fade top>
          <FaqEntry
            title="Life Sciences' Services often face inquiries regarding regulatory compliance, supply chain resilience, and capacity to scale operations. Where should I describe the details for such?"
            content={`
            These details are subject to dynamic changes, we recommend that you maintain updated PDFs
            attached to your profile and use the free text to highlight key compliance standards and
            recent achievements and capabilities.
            `}
            showBorder={false}
          />
        </Fade>

        <Fade top>
          <h3 className="mt-6 text-3xl text-main-900 font-extrabold mb-4">
            Licensing and platform
          </h3>
        </Fade>

        <Fade top>
          <FaqEntry
            title="Does Nucleo get a commission for deals closed?"
            content={`
            Unlike other Services, Nucleo does not take any commission related to any deals that
            parties make because of being connected on the platform. We believe in democratizing Life
            Sciences by being detached from any transaction.
            `}
          />
        </Fade>

        <Fade top>
          <FaqEntry
            title="I have a large database of products I wish to upload on the Nucleo database, is administrative help available for this?"
            content={`
            Yes, once a company has agreed to subscribe Nucleo will be happy to accept from the company
            their latest product list and to upload onto the platform. The final upload requires initial
            and periodic verification by the product owner to ensure compliance with our guiding
            principle 'one source of the truth' for any such product offering.
            `}
            showBorder={false}
          />
        </Fade>

        <Fade top>
          <h3 className="mt-6 text-3xl text-main-900 font-extrabold mb-4">
            My subscription
          </h3>
        </Fade>

        <Fade top>
          <FaqEntry
            title="What's the free trial period?"
            content={`
            We are pleased to offer an initial extended free trial period to allow you to evaluate the
            service, after which the service will transition to a paid subscription.
            `}
          />
        </Fade>

        <Fade top>
          <FaqEntry
            title="How long is my Free Trial period?"
            content={`
            We strongly encourage you to join for free now. No credit card required. We may introduce
            paid plans in the future, and we'll notify users clearly in advance before any charges apply.
            You will never be charged without your explicit consent.
            `}
            showBorder={false}
          />
        </Fade>

      </div>
    </section>
  );
}
